import React, { useState } from "react";
import PropTypes from "prop-types";
import ExperienceDisplay from "./experienceDisplay";
import EditExperience from "./editExperience";
import useExperience from "./useExperience";
import { scrollIntoView } from "utils/helper";

function AgencyExperience({ isShowEditIcon = true }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { onSaveExperience, isLoading } = useExperience();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleCancel = () => {
    setIsEditMode(false);
    scrollIntoView("experienceSection");
  };

  const handleSave = async (values) => {
    await onSaveExperience(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditExperience
        onCancel={handleCancel}
        onSave={handleSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <ExperienceDisplay
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

AgencyExperience.propTypes = {
  isShowEditIcon: PropTypes.bool,
};

export default AgencyExperience;
